import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/trhGqHnSffkjGnxXhUwbwQ/mindfulness_(3).png',
  label: 'Mindfulness · Respiración para bajar revoluciones'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cjJ4yuMqGpHRxE1K8hzRhg/mindfulness_(4).png',
  label: 'Mindfulness · Antes de responder en caliente'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cBZqGtpWSKTU9JRFB8RzCN/mindfulness_(20).png',
  label: 'Mindfulness · Tu pausa de emergencia cuando estás saturado'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1XRzweKUvZNRKZhDWKZtG1/KIT_CONVERSACIONES_DIFICILES_(4).png',
  label: 'Conversaciones Difíciles · Cuando te hablan mal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2Adpo4BLdEXKLmfoabzafx/KIT_CONVERSACIONES_DIFICILES_(14).png',
  label: 'Conversaciones Difíciles · Cómo salir de una conversación de chismes'
}];
export function PreviewSection() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(0);
  const go = (d: number) => {
    setDir(d);
    setIndex(p => (p + d + slides.length) % slides.length);
  };
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-211" data-mp="2gtl8uiir57vo">
      <div className="max-w-5xl mx-auto" data-id="element-212" data-mp="2guwbug4diblq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-213" data-mp="1t40cmxxl8e4g">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-214" data-mp="1y2bn9avpisnq">
            👀 Mirá el kit{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-215" data-mp="15epi3y6tzfyr">
              por dentro
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-3" data-id="element-216" data-mp="35fw2dh86jm3d">
            Páginas reales del material que vas a recibir
          </p>
        </motion.div>

        <div className="relative max-w-2xl mx-auto" data-id="element-217" data-mp="3f68nbajwpha1">
          <div className="relative bg-white border border-line rounded-3xl p-3 md:p-5 shadow-xl" data-id="element-218" data-mp="3f8lduc3qczyp">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-bg-warm" data-id="element-219" data-mp="3k7o76zaclhqu">
              <AnimatePresence initial={false} mode="wait" data-id="element-220" data-mp="2mjnzul6jxpbr">
                <motion.img key={index} src={slides[index].src} alt={slides[index].label} initial={{
                opacity: 0,
                x: dir > 0 ? 50 : -50
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: dir > 0 ? -50 : 50
              }} transition={{
                duration: 0.4
              }} className="absolute inset-0 w-full h-full object-contain" data-id="element-221" data-mp="2rhz6kn1jvjpr" />
              </AnimatePresence>
            </div>
          </div>

          <button onClick={() => go(-1)} aria-label="Anterior" className="absolute left-1 md:-left-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-222" data-mp="1rezpvjro6rq1">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-223" data-mp="18hgewalniz0z" />
          </button>
          <button onClick={() => go(1)} aria-label="Siguiente" className="absolute right-1 md:-right-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-224" data-mp="13j551zvcwoir">
            <ChevronRightIcon className="w-5 h-5" data-id="element-225" data-mp="1unboz916q4ae" />
          </button>
        </div>

        <div className="flex flex-col items-center gap-4 mt-6" data-id="element-226" data-mp="1zllnntm4bn0r">
          <div className="text-sm text-muted font-medium text-center px-4 font-serif-italic" data-id="element-227" data-mp="1zizejpjkwzgf">
            {slides[index].label}
          </div>
          <div className="flex gap-2" data-id="element-228" data-mp="1qjm7f3ixgmyv">
            {slides.map((_, i) => <button key={i} aria-label={`Material ${i + 1}`} onClick={() => {
            setDir(i > index ? 1 : -1);
            setIndex(i);
          }} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-8 bg-rose' : 'w-1.5 bg-rose/25'}`} data-id="element-229" data-mp="1bv98bxojmo05" data-mpi={i} />)}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-10" data-id="element-230" data-mp="swde4mcoq9mb">
          {slides.map((s, i) => <button key={i} onClick={() => {
          setDir(i > index ? 1 : -1);
          setIndex(i);
        }} className={`bg-white border rounded-2xl p-3 shadow-sm hover:shadow-lg transition-all ${i === index ? 'border-rose' : 'border-line'}`} data-id="element-231" data-mp="xwjcsmhdgwdw" data-mpi={i}>
              <img src={s.src} alt={s.label} className="w-full h-auto rounded-xl" data-id="element-232" data-mp="o95iqxi1e29s" />
            </button>)}
        </div>

        <p className="text-center font-serif-italic text-rose mt-8 text-lg" data-id="element-233" data-mp="x80sgjkahuhu">
          La mirada práctica del Método Aula Mater
        </p>
      </div>
    </section>;
}